<template>
  <v-card class="p-5">
    <Link :href="item.url" class=" flex flex-col justify-between">
      <div>{{ item.title }}
      </div>
      <div class="flex justify-end">
        <v-icon color="primary">
          mdi mdi-information-variant-circle-outline
        </v-icon>
      </div>
      
    </Link>
  </v-card>
</template>
<script setup>
defineProps({
  item: Object,
});
</script>
